<template>
  <b-modal size="lg" v-model="show" :title="$t(title)" title-tag="div" hide-footer>
    <div v-if="loading" class="loading_page">
      <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'" />
    </div>
    <div style="min-height: 300px;">
      <list-modal-table  class="mb-2" :items="modalData" :exportables="exportables"
        @onRowClick="(item, index, event) => rowClick(item, index, event)" :fields="fields.map((f) => {
          f.label = $t(f.label)
          f.sortable = true
          return f
        })" />
    </div>

  </b-modal>
</template>

<script>
import {
  BRow, BContainer, BButton, VBTooltip
} from 'bootstrap-vue'

import { ref } from '@vue/composition-api'
import ListModalTable from './ListModalTable.vue';
import { OrbitSpinner } from 'epic-spinners'

import Ripple from 'vue-ripple-directive'
import VueApexCharts from 'vue-apexcharts'
export default {
  components: {
    BButton,
    BRow,
    BContainer,
    OrbitSpinner,
    ListModalTable,
    VueApexCharts
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },

  props: {},

  setup(props, { root }) {

    const show = ref(false)
    const loading = ref(false)
    const exportables = ref([])

    const modalData = ref([])
    const fields = ref([])
    const title = ref('')

    const rowClick = ref((e) => { })

    const showModal = (config) => {
      show.value = true
      loading.value = true
      modalData.value = []
      Promise.resolve(config.list).then((payload) => {
        modalData.value = payload
      })
        .finally(() => loading.value = false)

      title.value = config.title
      fields.value = config.fields

      if (config.hasOwnProperty('onRowClick')) {
        rowClick.value = config.onRowClick
      }

      if (config.hasOwnProperty('exportables')) {
        exportables.value = config.exportables
      }
    }

    const setLoading = (bool) => {
      loading.value = bool
    }

    

    return {
      showModal,
      show,
      modalData,
      fields,
      title,
      loading,
      rowClick,
      setLoading,
      exportables
    }

  }
}
</script>
